import experiments from '../../common/constants/experiments'

export default {
  name: 'CodeCanyon',
  abbreviation: 'CC',
  domain: 'codecanyon.net',
  google_analytics_id: 'UA-11834194-12',
  google_remarketing_label: 'bdtlCM3-uQMQp-WC_AM',
  item_results_layout: 'list',
  home_search_placeholder: 'e.g. ecommerce plugin',
  assets_domains: {
    item_thumbnail: 'thumb-cc.s3.envato.com',
    item_image: 'image-cc.s3.envato.com'
  },
  experiments_to_features: {
    [experiments.codecanyonItemAttributes]: {
      0: {
        searchItemAttributes: false
      },
      1: {
        searchItemAttributes: false
      },
      2: {
        searchItemAttributes: true
      },
      3: {
        searchItemAttributes: true
      }
    }
  },
  features: {
    'experiments:loading-cover': true,
    'searchItemAttributes:enrolment': true,
    searchItemAttributes: false
  },
  feeds_categories: [
    '/category/javascript',
    '/category/php-scripts',
    '/category/net',
    '/category/wordpress',
    '/category/plugins',
    '/category/css',
    '/category/html5',
    '/category/mobile',
    '/category/apps',
    '/category/skins',
    '/category/edge-animate-templates'
  ],
  filterOrder: [
    'category',
    'tags',
    'price',
    'software-version',
    'compatible-with',
    'sales',
    'rating',
    'date-added'
  ]
}
